module.exports = __webpack_public_path__ + "assets/img/03b5be24469fb21a5dc53e3c16e56383.svg";